import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {i18nMixin} from '@aofl/i18n-mixin';
import {ApiService} from '@modules/api-service';
import {sdoNs} from '@modules/constants-enumerate';
import '@modules/group-summaries/sdo';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import translations from '@modules/i18n';

const BASE_CLASSES = {
  'dashboard-tile': true,
  'card': true,
  'border-top-0': true,
  'border-right-0': true,
  'card-border-color-left': true
};

/**
 * @summary GroupSummaries
 * @extends {AoflElement}
 */
@customElement('group-summaries')
class GroupSummaries extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of GroupSummaries.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.translations = translations;
  }
  /**
   * @readonly
   */
  static is = 'group-summaries';

  @property({type: Array, mapState: `${sdoNs.GROUP_SUMMARIES}.$summary`, store: storeInstance})
  summary = [];

  @property({type: Object, mapState: `${sdoNs.GROUP_SUMMARIES}.groupInfo`, store: storeInstance})
  groupInfo = {};

  @property({type: Boolean, mapState: `${sdoNs.GROUP_SUMMARIES}.loading`, store: storeInstance})
  loading = true;

  @property({type: Object, mapState: `${sdoNs.SESSION}.group_info`, store: storeInstance})
  sessionGroupInfo = {};

  @property({type: Boolean})
  isThirdPartyConnected = false;

  @property({type: String, attribute: false, mapState: `${sdoNs.SESSION}.type`, store: storeInstance})
  userType = '';

  cardClasses = [
    {
      ...BASE_CLASSES,
      'card-border-color-primary': true
    },
    {
      ...BASE_CLASSES,
      'card-border-color-warning': true
    },
    {
      ...BASE_CLASSES,
      'card-border-color-danger': true
    },
    {
      ...BASE_CLASSES,
      'card-border-color-success': true
    },
    {
      ...BASE_CLASSES,
      'card-border-color-purple': true
    },
    {
      ...BASE_CLASSES,
      'card-border-color-yellow': true
    },
    {
      ...BASE_CLASSES,
      'card-border-color-info': true
    }
  ];

  connectedCallback() {
    super.connectedCallback();
    const state = this.storeInstance.getState();

    this.loadSummary();
  }

  async loadSummary() {
    const payload = {};
    const commits = [];

    if (this.groupInfo && Object.keys(this.groupInfo).length) {
      let path = this.groupInfo.path;
      let subPaths = path.split(".");
      let alreadyInPath = false;

      for (let i = 0; i < subPaths.length; i++) {
        if (subPaths[i] == this.groupInfo.id) {
          alreadyInPath = true;
        }
      }

      if (this.groupInfo.id && !alreadyInPath) {
        path += this.groupInfo.id + '.';
      }
      payload.path = path;
    } else {
      commits.push({
        namespace: sdoNs.GROUP_SUMMARIES,
        mutationId: 'setGroupInfo',
        payload: this.sessionGroupInfo
      });
    }

    const summary = await ApiService.statsSummary(payload);
    commits.push({
      namespace: sdoNs.GROUP_SUMMARIES,
      mutationId: 'setSummary',
      payload: summary
    });
    commits.push({
      namespace: sdoNs.GROUP_SUMMARIES,
      mutationId: 'setLoading',
      payload: false
    });
    this.storeInstance.commit(...commits);
  }

  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.isThirdPartyConnected = (state[sdoNs.SESSION].$isTpRosteringConnected || this.groupInfo.is_third_party_connected);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.storeInstance.commit({namespace: sdoNs.GROUP_SUMMARIES, mutationId: 'setGroupInfo', payload: {}});
  }

  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default GroupSummaries;
